import Axios from "@/global/AxiosCall";
import {url} from '@/configs/apiUrl'

/**
 * default API response structure
 * {
 *     code: <integer>,
 *     message: <string>,
 *     data: <object>
 * }
 */
export default class MerchantAPI {

    /**
     * call API to get account merchant by user login
     *
     * @returns {Promise<unknown>}
     * @constructor
     */
    static AccountInfo() {
        return new Promise(((resolve, reject) => {
            Axios.Get(url.svd.merchant.merchant_user + '/' + JSON.parse(localStorage.getItem("userInfo")).id)
                .then((result) => {
                    if (result.code === 200)
                        resolve(result)
                }, (err) => {
                    reject(err)
                })
        }))
    }

    /**
     * call api save merchant
     * payload = {
     *     userDetails,
     *     notify()
     * }
     * @param payload
     * @returns {Promise<unknown>}
     */
    static Save(payload) {
        return new Promise(((resolve, reject) => {
            Axios.Post(url.svd.merchant.save, payload.merchantInfo)
                .then((result) => {
                    if (result.code === 200)
                        resolve(result)
                }, (err) => {
                    payload.notify(err.response.data.notify)
                    reject(err)
                })
        }))
    }

    /**
     * call API to update account info by merchant
     * payload = {
     *     id: <integer>,                   #id merchant
     *     merchantInfo: <object>
     * }
     * @param payload
     * @returns {Promise<unknown>}
     * @constructor
     */
    static UpdateAccountInfo(payload) {
        return new Promise(((resolve, reject) => {
            Axios.Put(url.svd.merchant.account_info + '/' + payload.id, payload.merchantInfo).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }, (err) => {
                //payload.notify(err.response.data.notify)
                reject(err)
            })
        }))
    }

    /**
     * call API for merchants to do verification
     *  payload = {
     *     id: <integer>,                   #id merchant
     *     merchantInfo: <object>
     * }
     * @param payload
     * @returns {Promise<unknown>}
     * @constructor
     */
    static Update(payload) {
        return new Promise(((resolve, reject) => {
            Axios.Put(url.svd.merchant.account_info + '/' + payload.id, payload.merchantInfo).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }, (err) => {
                //payload.notify(err.response.data.notify)
                reject(err)
            })
        }))
    }

    /**
     * call API to get list all merchant with pagination
     * payload = {
     *     page: <integer>,
     *     limit: <integer>
     * }
     * @param payload
     * @returns {Promise<unknown>}
     * @constructor
     */
    static ListMerchants(payload) {
        return new Promise(((resolve, reject) => {
            Axios.Get(url.svd.merchant.account_info + '?page=' + payload.page + '&limit=' + payload.limit).then(result => {
                if (result.code === 200)
                    resolve(result)
            }, (error) => {
                reject(error)
            })
        }))
    }

    /**
     * call api to get list merchants categories for option dropdown only
     * @returns {Promise<unknown>}
     * @constructor
     */
    static ListMerchantCategoryOptions() {
        return new Promise(((resolve, reject) => {
            Axios.Get(url.svd.merchant.categories).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }, (err) => {
                reject(err)
            })
        }))
    }

    /**
     * call api to get list merchants for option dropdown only
     * @returns {Promise<unknown>}
     * @constructor
     */
    static ListMerchantOptions() {
        return new Promise(((resolve, reject) => {
            Axios.Get(url.svd.merchant.list).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }, (err) => {
                reject(err)
            })
        }))
    }

    /**
     * call API to get merchant detail by id
     * @param payload
     * @returns {Promise<unknown>}
     * @constructor
     */
    static MerchantDetail(payload) {
        return new Promise(((resolve, reject) => {
            let cond = (payload.condition !== undefined )? "?cond=true" :""
            Axios.Get(url.svd.merchant.account_info + '/' + payload.id +cond)
                .then((result) => {
                    if (result.code === 200)
                        resolve(result)
                }, (err) => {
                    payload.notify(err.response.data.notify)
                    reject(err)
                })
        }))
    }

    /**
     * call API to set merchant status
     * @param payload
     * @returns {Promise<unknown>}
     * @constructor
     */
    static SetStatus(payload) {
        return new Promise(((resolve, reject) => {
            Axios.Put(url.svd.merchant.setStatus + '/' + payload.id, {status: payload.status})
                .then((result) => {
                    if(result.code === 200){
                        resolve(result)
                    } else {
                        reject(Error(result.message))
                    }
                }, (err) => {
                    reject(err)
                })
        }))
    }

    /**
     * call API for merchants to do verification request
     *  payload = {
     *     id: <integer>,                   #id merchant
     *     merchantInfo: <object>
     * }
     * @param payload
     * @returns {Promise<unknown>}
     * @constructor
     */
    static RequestVerification(payload) {
        return new Promise(((resolve, reject) => {
            Axios.Put(url.svd.merchant.request_verification + '/' + payload.id, payload.merchantInfo).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }, (err) => {
                //payload.notify(err.response.data.notify)
                reject(err)
            })
        }))
    }
}